"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shallowEqualIRTermHash = exports.equalIRTermHash = void 0;
var IRHash_1 = require("../IRHash.js");
/**
 * forces hash evaluation
 */
function equalIRTermHash(a, b) {
    return a === b || (0, IRHash_1.equalIrHash)(a.hash, b.hash);
}
exports.equalIRTermHash = equalIRTermHash;
/**
 * only checks the hash if already present ON BOTH
 *
 * otherwise it assumes the terms are different and returns false
 * (even if they might be the same)
 */
function shallowEqualIRTermHash(a, b) {
    if (a === b)
        return true;
    return (a.isHashPresent() && b.isHashPresent() &&
        (0, IRHash_1.equalIrHash)(a.hash, b.hash));
}
exports.shallowEqualIRTermHash = shallowEqualIRTermHash;
